import { ComingSoon } from "@/components/coming-soon";
import { useTranslation } from "@/i18n/use-translation";

export default function WasteSummaryPage() {
  const { t } = useTranslation();
  return <ComingSoon title={t("waste.summaryTitle")} description={t("waste.summaryDescription")} />;
}
